module.exports = __webpack_public_path__ + "media/02d.beceffbe.mp4";